import { ActionMessage } from 'satcheljs';
import { ActionMetaInfo } from 'mini-app-context';
import { addDatapointMiddleware, PerformanceDatapoint } from 'owa-analytics';

export function datapointMiddleware(next: any, metaInfo: ActionMetaInfo, ctx: any, ...args: any[]) {
    try {
        const actionMsg: ActionMessage = {
            type: metaInfo.name,
            dp: metaInfo,
            actionDatapoint: new PerformanceDatapoint(metaInfo.name, metaInfo.options),
        };
        let result;
        addDatapointMiddleware(_ => {
            result = next && next(metaInfo, ctx, ...args);
        }, actionMsg);
        return result;
    } catch {
        return next && next(metaInfo, ctx, ...args);
    }
}
